module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my",
    class: [_vm.classes, {
      'manabi-subject': _vm.$store.getters['config/isManabi']
    }],
    attrs: {
      "id": ("subject-" + _vm.id)
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('dl', {
    staticClass: "my__body"
  }, [_c('dt', {
    staticClass: "my__name"
  }, [_c('dn-chk-btn', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [_c('div', {
    staticClass: "my__detail__column my__select-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "selfcheck"
    }
  }, [_vm._v("解答入力")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "direct"
    }
  }, [_vm._v("点数入力")])])]), _vm._v(" "), _c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.storeDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n          点\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__action"
  }, [_c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": "",
      "sm": "",
      "disabled": !_vm.selected || !_vm.anyDirectScoreIsUpdated
    },
    on: {
      "click": _vm.storeDirectScore
    }
  }, [_vm._v("\n            登録\n          ")]), _vm._v(" "), _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type + "--clear"),
    staticClass: "my__action__btn",
    attrs: {
      "sm": "",
      "disabled": !_vm.selected || !_vm.hasAnyScore
    },
    on: {
      "click": _vm.clearDirectScore
    }
  }, [_vm._v("\n            削除\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score : '---'))]), _vm._v("/"), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])]), _vm._v(" "), (_vm.children.length) ? _c('div', {
    staticClass: "my__children"
  }, _vm._l((_vm.children), function(child) {
    return _c('my-child-subject', {
      key: child.id,
      ref: "child-subject",
      refInFor: true,
      staticClass: "my__child",
      attrs: {
        "id": child.id,
        "type": _vm.type,
        "selected": _vm.selected,
        "fixed": _vm.fixed,
        "direct-score-bucket": _vm.directScoreBucket,
        "directscore-changes-bucket": _vm.directScoreChangesBucket
      },
      on: {
        "updateDirectScoreBucket": function($event) {
          _vm.directScoreBucket = $event
        },
        "updateDirectScoreChangesBucket": function($event) {
          _vm.directScoreChangesBucket = $event
        },
        "submit-directscore": _vm.storeDirectScore
      }
    })
  })) : _vm._e()] : [_c('dl', {
    staticClass: "my__body"
  }, [_c('dt', {
    staticClass: "my__name"
  }, [_c('dn-chk-btn', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [_c('div', {
    staticClass: "my__detail__column my__select-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "selfcheck"
    }
  }, [_vm._v("解答入力")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "direct"
    }
  }, [_vm._v("点数入力")])])]), _vm._v(" "), (_vm.isDirect) ? _c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.storeDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n        点\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__action"
  }, [(_vm.isSelfCheck) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": !_vm.fixed,
      "plain": _vm.fixed,
      "sm": "",
      "disabled": !_vm.selected,
      "href": ("./" + _vm.id + ".html")
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickSubjectSelfCheck($event)
      }
    }
  }, [_c('dn-icon', {
    class: _vm.fixed || !_vm.selected ? 'is-disabled' : 'is-white',
    attrs: {
      "icon": "pen"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.fixed ? '採点しなおす' : '採点'))])], 1) : _vm._e(), _vm._v(" "), (_vm.isDirect) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": "",
      "sm": "",
      "disabled": !_vm.selected || !_vm.anyDirectScoreIsUpdated
    },
    on: {
      "click": _vm.storeDirectScore
    }
  }, [_vm._v("\n          登録\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isDirect) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type + "--clear"),
    staticClass: "my__action__btn",
    attrs: {
      "sm": "",
      "disabled": !_vm.selected || !_vm.hasAnyScore
    },
    on: {
      "click": _vm.clearDirectScore
    }
  }, [_vm._v("\n          クリア\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score + '点' : '---'))]), _vm._v(" "), _c('span', {
    staticClass: "my__score__separator"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])]), _vm._v(" "), (_vm.children.length) ? _c('div', {
    staticClass: "my__children"
  }, _vm._l((_vm.children), function(child) {
    return _c('my-child-subject', {
      key: child.id,
      ref: "child-subject",
      refInFor: true,
      staticClass: "my__child",
      attrs: {
        "id": child.id,
        "type": _vm.type,
        "selected": _vm.selected,
        "fixed": _vm.fixed,
        "direct-score-bucket": _vm.directScoreBucket,
        "directscore-changes-bucket": _vm.directScoreChangesBucket
      },
      on: {
        "updateDirectScoreBucket": function($event) {
          _vm.directScoreBucket = $event
        },
        "updateDirectScoreChangesBucket": function($event) {
          _vm.directScoreChangesBucket = $event
        },
        "submit-directscore": _vm.storeDirectScore
      }
    })
  })) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e19bb8c","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/jikosaiten/index/components/Subject.vue
// module id = 916
// module chunks = 3